module.exports = __webpack_public_path__ + "assets/img/small_rx_icon.c73b8dda.svg";